import { render, staticRenderFns } from "./CenterList.vue?vue&type=template&id=7ab77791&scoped=true&"
import script from "./CenterList.vue?vue&type=script&lang=ts&"
export * from "./CenterList.vue?vue&type=script&lang=ts&"
import style0 from "./CenterList.vue?vue&type=style&index=0&id=7ab77791&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab77791",
  null
  
)

component.options.__file = "CenterList.vue"
export default component.exports